import { without, find } from 'lodash';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

export class ModalService {
    private modals: any[] = [];
    modalOpenClose$: Subject<Boolean>;
    
    add(modal: any) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(id: string) {
        // remove modal from array of active modals
        let modalToRemove = find(this.modals, { id: id });
        if (!modalToRemove){
            console.error('ModalService.remove() >> Can\'t find a modal with id:' + id);
            return;
        }
        this.modals = without(this.modals, modalToRemove);
    }

    open(id: string) {
        // open modal specified by id
        let modal = find(this.modals, { id: id });
        if (!modal){
            console.error('ModalService.open() >> Can\'t find a modal  with id:' + id);
            return;
        }
        modal.open();
        this.modalAction(true);        
    }

    close(id: string) {
        // close modal specified by id
        let modal = find(this.modals, { id: id });
        if (!modal){
            console.error('ModalService.close() >> Can\'t find a modal  with id:' + id);
            return;
        }
        modal.close();
        this.modalAction(false);
    }

    modalAction(open:Boolean){
        this.modalOpenClose$.next(open);
    }

    subscribeToModalOpenClose(): Observable<Boolean> {
        if (!this.modalOpenClose$)
            this.modalOpenClose$ = new Subject<Boolean>();
        return this.modalOpenClose$.asObservable();
    }

    modalExists(id: string): Boolean{
        let modal = find(this.modals, { id: id });
        if (!modal)
            return false;
        return true;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/modal/_services/modal.service.ts